import React, { useEffect, useState } from 'react';
import { Grid, Modal } from '@mui/material';
import { useAppSelector } from '../../../redux/store';
import { updateAccountControl } from '../../../redux/commonSlice';

const AccountControl: React.FC<any> = ({ open, handleClose }) => {
  const { accountControl } = useAppSelector(state => state.common);
  const [messagePermission, setMessagePermission] = useState<string>('');
  const [visibility, setVisibility] = useState<boolean>(false);

  useEffect(() => {
    if (accountControl) {
      setMessagePermission(accountControl.messagePermission);
      setVisibility(accountControl.visibility);
    }
  }, [accountControl]);

  const handlePermissionChange = (value: string) => {
    setMessagePermission(value);
    updateAccountControl({ messagePermission: value });
  };

  const handleVisibilityToggle = () => {
    const newValue = !visibility;
    setVisibility(newValue);
    updateAccountControl({
      visibility: newValue,
      messagePermission: messagePermission,
    });
  };

  return (
    <Modal open={open} className="modal-main">
      <div className="modal-dialog med">
        <div className="modal-content">
          <div className="modal-title d-flex flex-between align-center">
            <p className="title text-gray_700 fw500">Account Controls</p>
            <button className="blank-btn" onClick={handleClose}>
              <i className="cross-icon"></i>
            </button>
          </div>

          <div className="modal-body pt-15 pb-15">
            <div className="body-scroll-sm pt-12 access-modal">
              <p className="text-text MuiTypography-subtitle1 mb-16">
                Manage your message settings to control who can send you
                messages.
              </p>

              {/* Radio: Everyone */}
              <Grid container spacing={2} className="align-center">
                <Grid item lg={10} sm={9}>
                  <p className="MuiTypography-body2 lh-14 mb-6 fw500">
                    Everyone on the Reeltrak
                  </p>
                  <p className="text-text MuiTypography-subtitle1">
                    Anyone on ReelTrak can message you.
                  </p>
                </Grid>
                <Grid item lg={2} sm={3} className="text-right">
                  <div className="radio">
                    <input
                      type="radio"
                      name="messagePermission"
                      checked={messagePermission === 'EVERYONE'}
                      onChange={() => handlePermissionChange('EVERYONE')}
                    />
                    <label></label>
                  </div>
                </Grid>
              </Grid>

              <hr />

              {/* Radio: Production only */}
              <Grid container spacing={2} className="align-center">
                <Grid item lg={10} sm={9}>
                  <p className="MuiTypography-body2 lh-14 mb-6 fw500">
                    Only contacts in the same Production
                  </p>
                  <p className="text-text MuiTypography-subtitle1">
                    Only contacts from the same production can message you.
                  </p>
                </Grid>
                <Grid item lg={2} sm={3} className="text-right">
                  <div className="radio">
                    <input
                      type="radio"
                      name="messagePermission"
                      checked={messagePermission === 'PRODUCTION'}
                      onChange={() => handlePermissionChange('PRODUCTION')}
                    />
                    <label></label>
                  </div>
                </Grid>
              </Grid>

              <hr />

              <p className="MuiTypography-body2 lh-14 mb-4 fw500">
                Privacy Control
              </p>
              <p className="text-text MuiTypography-subtitle1 mb-16">
                Manage your privacy settings to control your visibility to get
                added in the production.
              </p>

              <Grid container spacing={2} className="align-end">
                <Grid item lg={10.5} sm={9}>
                  <p className="MuiTypography-body2 lh-14 mb-4 fw500">
                    Only contacts in the same Production
                  </p>
                  <p className="text-text MuiTypography-subtitle1">
                    By turning on the visibility, your confidential information
                    will be hidden.
                  </p>
                </Grid>
                <Grid item lg={1.5} sm={3} className="text-right">
                  <div className="switch d-inline-flex">
                    <input
                      id="visibility-toggle"
                      type="checkbox"
                      checked={visibility}
                      onChange={handleVisibilityToggle}
                    />
                    <label htmlFor="visibility-toggle">
                      <div className="key"></div>
                    </label>
                  </div>
                </Grid>
              </Grid>

              <hr />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AccountControl;
